// extracted by mini-css-extract-plugin
export default {"header":"styles_header__5scPQ","wrapper":"styles_wrapper__Cr72U","logo":"styles_logo__b2HZy","burger":"styles_burger__y+ZYQ","unread":"styles_unread__fSqz2"};